// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3At_S","content":"GlobalSearch_content__2e4yb"};